import { ImpersonationAction } from "../reducers/impersonation";

export const IMPERSONATION_SET_IMPERSONATOR =
  "IMPERSONATION_SET_IMPERSONATOR" as const;
export const IMPERSONATION_SET_TIMING_OUT =
  "IMPERSONATION_SET_TIMING_OUT" as const;
export const IMPERSONATION_SET_TIMED_OUT =
  "IMPERSONATION_SET_TIMED_OUT" as const;
export const IMPERSONATION_RESET = "IMPERSONATION_RESET" as const;

export const setImpersonator = (
  impersonator?: string
): ImpersonationAction => ({
  type: IMPERSONATION_SET_IMPERSONATOR,
  impersonator,
});

export const setImpersonatorTimingOut = (
  isTimingOut: boolean
): ImpersonationAction => ({
  type: IMPERSONATION_SET_TIMING_OUT,
  isTimingOut,
});

export const setImpersonatorTimedOut = (
  isTimedOut: boolean
): ImpersonationAction => ({
  type: IMPERSONATION_SET_TIMED_OUT,
  isTimedOut,
});

export const resetImpersonatorState = (): ImpersonationAction => ({
  type: IMPERSONATION_RESET,
});
